import { MARKETING_CONSENT_VERSION } from '@geo-admin/shared/contract/api/signup.ts';
import { BRAND, COMPANY } from '../../lib/company.ts';
import type { LegalDoc } from '../types.ts';

/**
 * (선택) 마케팅 정보 수신 동의 — 광고성 정보 전송(정보통신망법 제50조)의 사전 동의 문안.
 * 구조는 selfad 의 광고성 정보 수신 동의를 따랐다(목적·매체·항목·기간·거부 권리·철회).
 * ★ 문안을 고치면 MARKETING_CONSENT_VERSION 을 올린다 — 어느 문안으로 동의받았는지가 계정에 판으로 남는다.
 * ★ 철회 화면이 생기면 5항을 고친다(지금은 문의로 받는다 — 260917-signup-marketing-consent).
 */
export const marketingConsent: LegalDoc = {
  title: '마케팅 정보 수신 동의 (선택)',
  effectiveDate: MARKETING_CONSENT_VERSION,
  blocks: [
    {
      kind: 'p',
      text: `${COMPANY.name}(이하 "회사")는 ${BRAND.name} 서비스와 관련된 소식, 이벤트, 혜택 등 광고성 정보를 보내기 위하여 아래와 같이 수신 동의를 받습니다.`,
    },

    { kind: 'h2', text: '1. 전송 목적' },
    {
      kind: 'ul',
      items: [
        '신규 서비스·기능 안내',
        '이벤트, 프로모션, 할인·혜택 안내',
        'AI 검색 최적화(GEO) 관련 활용 정보, 세미나·웨비나 안내',
      ],
    },

    { kind: 'h2', text: '2. 전송 방법' },
    { kind: 'p', text: '회사는 아래 방법으로 광고성 정보를 보낼 수 있습니다.' },
    { kind: 'ul', items: ['이메일', '문자메시지(SMS·LMS)', '카카오톡'] },
    {
      kind: 'p',
      text: '오후 9시부터 다음 날 오전 8시 사이에는 별도로 동의를 받지 않는 한 광고성 정보를 보내지 않습니다.',
    },

    { kind: 'h2', text: '3. 이용 항목 및 보유·이용 기간' },
    {
      kind: 'table',
      head: ['이용 항목', '보유·이용 기간'],
      rows: [['이메일 주소, 휴대폰 번호, 업체명', '동의일부터 동의를 철회하거나 회원에서 탈퇴할 때까지']],
    },

    { kind: 'h2', text: '4. 동의를 거부할 권리' },
    {
      kind: 'p',
      text: `이 동의는 선택 사항입니다. 동의하지 않으셔도 ${BRAND.name} 가입과 서비스 이용에는 제한이 없습니다. 다만 이벤트·혜택 등의 안내를 받으실 수 없습니다.`,
    },

    { kind: 'h2', text: '5. 수신 동의 철회' },
    {
      kind: 'p',
      text: `언제든지 동의를 철회하실 수 있습니다. 대표번호(${COMPANY.tel}), 카카오톡 상담, 이메일(${COMPANY.email})로 알려 주시면 처리해 드리며, 받으신 광고성 정보에 안내된 수신 거부 방법으로도 철회하실 수 있습니다.`,
    },
  ],
};
